export { default } from './RehabResult.component';
